var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDay2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000180367275627543438610000011312948170030028948_);}\r\n\t.st2{fill:url(#SVGID_00000182498383669252233000000004079094055262289568_);}\r\n\t.st3{fill:url(#SVGID_00000142892914292018931150000015646738549963166620_);}\r\n\t.st4{fill:url(#SVGID_00000147214379021408653860000006451235567790796676_);}\r\n\t.st5{fill:url(#SVGID_00000090982608530480890460000006290130278265587645_);}\r\n\t.st6{fill:url(#SVGID_00000131353733435599191880000007716492086127269289_);}\r\n\t.st7{fill:url(#SVGID_00000061453453480362123050000017373489394611647126_);}\r\n\t.st8{fill:url(#SVGID_00000007415476292144451170000010946001123619251897_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8882,
    y1: 32,
    x2: 48.229,
    y2: 32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,48.2c-8.9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2c8.9,0,16.2,7.3,16.2,16.2S41,48.2,32.1,48.2z  M32.1,18.8c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2c7.3,0,13.2-5.9,13.2-13.2C45.2,24.7,39.3,18.8,32.1,18.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071561148970250396450000012142769307154386562_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1079,
    y1: 31.3621,
    x2: 63.8335,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000071561148970250396450000012142769307154386562_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178172500237417966820000005038636107817680270_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1665,
    y1: 31.3621,
    x2: 10.8921,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000178172500237417966820000005038636107817680270_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106865333228680237500000006485288912742668724_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 5.5293,
    x2: 33.5005,
    y2: 5.5293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.2,
    style: {
      fill: "url(#SVGID_00000106865333228680237500000006485288912742668724_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107584601852709397500000013240978543071675282_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 58.4707,
    x2: 33.5005,
    y2: 58.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 53.1,
    style: {
      fill: "url(#SVGID_00000107584601852709397500000013240978543071675282_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115495905028887267670000012965368330464447631_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 11.752,
    x2: 17.3013,
    y2: 11.752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000115495905028887267670000012965368330464447631_)"
    },
    points: "15.2,16.6 7.6,9 9.7,6.9  17.3,14.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006692933807496683960000009917416962117724061_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 49.187,
    x2: 54.7368,
    y2: 49.187
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000006692933807496683960000009917416962117724061_)"
    },
    points: "52.6,54 45,46.5 47.2,44.3  54.7,51.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163074597013416514590000007357643771736666553_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 49.6968,
    x2: 17.3013,
    y2: 49.6968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163074597013416514590000007357643771736666553_)"
    },
    points: "9.7,54.5 7.6,52.4 15.2,44.8  17.3,47  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001649286390675343580000015584648415092152211_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 12.2615,
    x2: 54.7368,
    y2: 12.2615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C0C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4990CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#685197"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000001649286390675343580000015584648415092152211_)"
    },
    points: "47.2,17.1 45,15 52.6,7.4  54.7,9.5  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay2);
export default __webpack_public_path__ + "static/media/icon_day2.3a686f97e6f70a82092692926f472dc8.svg";
export { ForwardRef as ReactComponent };